var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-block-loader"},[_c('div',{staticClass:"ui-block-loader-spinner",class:{
            _dark: _vm.dark,
            _light: _vm.light,
            _centered: _vm.centered,
            _mini: _vm.isMini,
            _sm: _vm.size === 'sm',
            _md: _vm.size === 'md',
            _lg: _vm.size === 'lg',
        },style:({
            width: _vm.fixed ? _vm.fixed + 'px' : null,
            paddingTop: _vm.fixed ? _vm.fixed + 'px' : null,
        })})])
}
var staticRenderFns = []

export { render, staticRenderFns }